import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import DeliveryPackageGroup from '../entities/grouping-packages/delivery-package-group';

interface DeliveryPackageGroupState extends ListState<DeliveryPackageGroup>{
}

class DeliveryPackageGroupModule extends ListModule<DeliveryPackageGroupState,any,DeliveryPackageGroup>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<DeliveryPackageGroup>(),
        loading:false,
    }
    actions={
        async getAll(context:ActionContext<DeliveryPackageGroupState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GroupingPackage/Search',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<DeliveryPackageGroup>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async viewGroupingPackage(context:ActionContext<DeliveryPackageGroupState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/GroupingPackage/ViewGroupingPackage?code='+payload.data.code);
            return reponse.data.result;
        },
        async getInfoPackageToGroup(context:ActionContext<DeliveryPackageGroupState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/GroupingPackage/GetInfoPackageToGroup?packageCode='+payload.data.code);
            return reponse.data.result;
        },
        async createOrUpdateGroupingPackage(context:ActionContext<DeliveryPackageGroupState,any>,payload:any){
            let reponse=await Ajax.put('/api/services/app/GroupingPackage/CreateOrUpdateGroupingPackage', payload.data);
            return reponse.data.result;
        }
    };
    mutations={
        setCurrentPage(state:DeliveryPackageGroupState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:DeliveryPackageGroupState,pagesize:number){
            state.pageSize=pagesize;
        },
        setLoading(state:DeliveryPackageGroupState,loading:boolean){
            state.loading=loading;
        }
    }
}
const deliveryPackageGroupModule=new DeliveryPackageGroupModule();
export default deliveryPackageGroupModule;